

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const TEXT = 'text'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TEXT]: {
      label: ``,
      name: TEXT,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TEXT]: '',
}
/**
 * Form data validation
 */
 export const validationSchema = () =>
 yup.object().shape({
     [TEXT]: yup.string(),
 })

export default formModel
